import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth54: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M149.1,70.3s-10.9,13.1-23.3,13.1-10-14.7-22.7-14.3-13.2,14-23.7,14-22.4-12-22.4-12c15.7,20.7,0,46.3,0,46.3,0,0,10-14.3,22.6-14.3,12.6,0,9.9,13.3,23.5,13.3s13.7-13,23.2-13,24.2,13.6,22.7,11.8c-18-21.3.2-44.9.2-44.9h-.1Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M161.9,50.7l12.2,10.4,4.2,4.5,2.7,5.2,1.7,5.9v16.6s-1.2,7.5-1.2,7.5l-1.3,5.7-2.4,6.4-2.5,4.5-10.8,14.3c-9.8-11.6-15.5-16.5-15.5-16.5-17.8-21.9.2-44.9.2-44.9,9.8-8.5,12.7-19.7,12.7-19.7h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M57.2,71.3c-13.5-9.6-16-18.6-16-18.6l-6.8,10-4,6.6-1.9,10.6v29.1s2.7,12.1,2.7,12.1l8.2,16.7c8.6-13.6,17.7-20.3,17.7-20.3,15.3-29.5,0-46.3,0-46.3h.1Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M164.5,132l-16.1,15.1-6.3,7.3-6.7,9.9-5.6,7.4-5.9,3.5-8.8,3.5-8.1,1.5h-7.6s-11.1-2.7-11.1-2.7l-14-6.2-10.5-6.6-13.5-13-11-13.9c9.9-14.6,17.7-20.3,17.7-20.3,0,0,10.5-14.3,22.6-14.3,12.1,0,10.4,13.3,23.5,13.3,13.1,0,14.8-13,23.2-13s22.7,11.8,22.7,11.8c2.4,1.1,15.5,16.5,15.5,16.5v.2Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M162,50.7c-.3,8.7-12.7,19.7-12.7,19.7,0,0-11.9,13.1-23.3,13.1s-11.7-14.3-22.7-14.3-12.9,14-23.7,14-10-3.8-22.4-12c-12.4-8.2-16-18.6-16-18.6l15.2-9.3,4.2-4,5.2-3,7.6-4.4,8.7-2.8,5.8-1.1h14s4,1,4,1h15.1s5.2.8,5.2.8l16.7,8.6,19,12.2h.1Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M164.4,131.6c-71.3,40.2-125.1,6-125.1,6l11,13.9,13.5,13,10.5,6.6,14,6.2,11.1,2.7h7.6s8.1-1.5,8.1-1.5l8.8-3.5,5.9-3.5,5.6-7.4,6.7-9.9,6.3-7.3,16.1-15.1v-.2Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M162,50.6c-71.6-23.1-120.8,2-120.8,2l15.2-9.3,4.2-4,5.2-3,7.6-4.4,8.7-2.8,5.8-1.1h14s4,1,4,1h15.1s5.2.8,5.2.8l16.7,8.6,19,12.2h.1Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M151.5,142.9c-8,6.9-12.4,15.2-18.8,23-7.4,9-19.9,13.8-31.7,12.8-15.3-1.3-28.2-8.7-39.9-17.9s-18.5-18.3-24.8-30.3c-6.3-12.1-8.7-23.7-8.6-37.8.1-14.8,3.3-31.6,15.8-41.1l21.7-14.3c12.5-8.2,27.1-9.5,41.6-8.4s17-.4,24.8,3.4,15.6,8.8,23.2,13.6,13.5,10.3,19.3,16.7c3.8,4.2,6.7,8.6,7.3,14.7,2.7,29.1-7.9,46.5-30,65.6Z',
			},
		},
	},
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M34.5,147.4l-.8-21c37.8,0,32.4-40.8,32.4-40.8h84.1c0,46.8,32.4,40.8,32.4,40.8l-11.5,21c-75.4,28.7-136.6,0-136.6,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M150.2,85.4c0,46.8,32.4,40.8,32.4,40.8l2.1-3.5,2.9-7.3,3.5-10.6,1.8-7.6v-6.5s-1.3-5.3-1.3-5.3l-3.5-6.2-4.4-5.1-3.8-.4-4.4-5.3-4.1-3.5-7.4-4.1-4.4-3.2-9.3-10v38s-.1-.2-.1-.2Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M33.7,126.4l-2.6-27.1v-17.7s2.6-6.3,2.6-6.3l5.1-7.9,4.3-2.6,8.2-5.6,7.2-4.3h7.6v30.7c2.5,44.2-32.4,40.8-32.4,40.8Z',
			},
			[ToothSurface.PalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M66.2,85.7c.7,0-34.9,0-34.9,0v-4s2.6-6.3,2.6-6.3l5.1-7.9,4.3-2.6,8.2-5.6,7.2-4.3h7.6s3.9,1.2,3.9,1.2h2.8s2.9-1.2,2.9-1.2l3.4-3.7,4.6-3.5,4.7-2.8,6.2-2.6,4.7-2.2,7.8-3.2,6.2-2.2,4.1-.9,5.6-1.2,5.9,1.3,10.8,5.4,10.5,8.4,9.3,10,4.4,3.2,7.4,4.1,4.1,3.5,4.4,5.3,3.8.4,4.4,5.1,3.5,6.2h-125.6s.1.1.1.1Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M171.2,147.5c-78.1,29.1-136.6,0-136.6,0l-.8-21-2.6-27.1v-17.7s2.6-6.3,2.6-6.3l5.1-7.9,4.3-2.6,8.2-5.6,7.2-4.3h7.6s3.9,1.2,3.9,1.2h2.8s2.9-1.2,2.9-1.2l3.4-3.7,4.6-3.5,4.7-2.8,6.2-2.6,4.7-2.2,7.8-3.2,6.2-2.2,4.1-.9,5.6-1.2,5.9,1.3,10.8,5.4,10.5,8.4,9.3,10,4.4,3.2,7.4,4.1,4.1,3.5,4.4,5.3,3.8.4,4.4,5.1,3.5,6.2,1.3,5.3v6.5s-1.8,7.6-1.8,7.6l-3.5,10.6-2.9,7.3-2.1,3.5-11.5,21h.1Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M34.5,147.4s61.1,28.6,136.6,0l-4.1,8.2s-49.6,28.8-131.5,0l-.9-8.3Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M132,171.9c-37.9,11.1-72.2-5.9-97.9-33.8l-1.4-31.8c-.9-20.7-3.7-32.8,14.5-44.2l11.6-7.3c4.8-3,11.9,5.2,19.1-1.9,5.3-5.2,12.1-8.1,18.9-10.9,10.9-4.6,21.7-11.5,32-7.5s22.3,13.7,31.3,23.4,6.3,5,9.5,6.3,6.1,6.2,9.7,8.4c7.9,4.8,14,12.1,12.9,22.4-1.4,13.5-6.3,26.4-13.1,38.3s-7.1,16.1-13.1,21c-10.5,8.4-21.6,14-34,17.7Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M185.5,390.6c-31.2,0-28.6,38.9-28.6,38.9H58.3c0-43.1-28.5-42.3-28.5-42.3l7.1-13.7,5.4-11.2.2-3.8c72.9-49.7,119.9-2.4,119.9-2.4l4.2,5,18.9,29.4h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M156.9,429.5c-.6-41.8,28.6-38.9,28.6-38.9l3.6,8.3,3.4,11,1.1,11.3v16.8s-3.5,9.3-3.5,9.3l-12.3,10.9-20.9,14.9v-43.7s0,.1,0,.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M58.2,429c0-43.5-28.5-41.9-28.5-41.9l-3.5,6-3.8,8.7-3.3,9.4-1.9,9.2v10.3s.9,7.1.9,7.1l3.5,7,5.2,5.9,9.4,7,8.9,4.2,6.8,1,6.4-1v-32.9s0,0,0,0Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '193.6 429.4 193.6 438 190.1 447.3 177.8 458.2 156.9 473.1 146.6 477 135.4 477.3 131.2 476.4 119.5 481.9 108.7 481.9 96.6 476.4 82.2 470.3 77.8 467.5 70.9 461.3 58.3 461.9 51.9 463 45.1 461.9 36.2 457.7 26.8 450.8 21.6 444.9 18.1 437.9 17.2 429.4 58.3 429.4 156.9 429.4 193.6 429.4',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M162.4,356.2v-8.1c-53.7-47.3-119.9,1.5-119.9,1.5v8.9c72.6-49.6,119.9-2.4,119.9-2.4h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M185.5,390.6l3.6,8.3,3.4,11,1.1,11.3v16.8s-3.5,9.3-3.5,9.3l-12.3,10.9-20.9,14.9-10.3,4-11.2.3-4.1-.9-11.8,5.5h-10.7s-12.1-5.5-12.1-5.5l-14.4-6.1-4.4-2.8-6.9-6.3-12.6.7-6.4,1-6.8-1-8.9-4.2-9.4-7-5.2-5.9-3.5-7-.9-8.5v-8.9s1.9-9.2,1.9-9.2l3.3-9.4,7.3-14.7,12.5-24.9.2-3.8c72.7-50.4,119.9-2.4,119.9-2.4l4.2,5,18.9,29.4h0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M107.1,480.3l-16.5-6.9c-7.4-3.1-14.1-6.7-19.4-12.9-3-.2-5.6,1.2-8.3,1.3l-11.8.5c-8.6.4-15.4-5.6-21.9-10.4s-10-10.1-11-18.1c-1.7-14.1,1.4-27.9,8.1-40.3l12.7-23.3c24.8-17.2,58.4-36,88.3-34.3s27.4,8.4,34.7,21.2c7.4,12.9,20.3,23.8,26.9,42,4.5,12.4,5.1,26,4.2,38.9s-3.8,10.4-8.1,14.1c-8.8,7.5-17.2,15-27.4,20.6s-17.3,4-26.5,3.6c-9.2,2.4-12.8,8.9-24,4.2Z',
			},
		},
	},
};
